import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../../components';
import { Box } from '@mui/material';

const ProductTabScreen = () => {
  const navigate = useNavigate();

  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Recargas Celular",
            route: '/admin/productos/tae',
            onChange: () => navigate('tae'),
            content: <Outlet />
          },
          {
            name: "Pago de Servicios",
            route: '/admin/productos/pds',
            onChange: () => navigate('pds'),
            content: <Outlet />
          },
          {
            name: "Tarjetas de Regalo",
            route: '/admin/productos/pin',
            onChange: () => navigate('pin'),
            content: <Outlet />
          }
        ].filter(Boolean)}
      />
    </Box>
  );
}

export default ProductTabScreen